import React, { useRef, useEffect } from 'react';
import Chart from 'chart.js/auto';

const PieChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  useEffect(() => {
    if (chartRef && chartRef.current) {
      // Détruire le graphique existant avant de créer un nouveau graphique
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
      // Créer un nouveau graphique
      chartInstanceRef.current = new Chart(chartRef.current, {
        type: 'pie',
        data: data,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Chart.js Pie Chart'
            }
          }
        }
      });
    }
  }, [data]);

  return (
    <canvas ref={chartRef} />
  );
};

export default PieChart;